import Page from './look-code'
export default Page